<template lang="pug">
  div
    .input-group
      button.btn.btn-link(@click='() => $refs.modalAnexos.open([])')
        btn-content(icon='fa fa-upload' label='Upload de Planta')
    modal-anexos(@saveAnexos='onSelect' ref="modalAnexos" title="Enviar plantas" :id="id" :compress="false")
</template>

<script>
export default {
  props: {
    plantas: { type: Array, required: true },
    disabled: { type: Boolean, default: false },
    id: { required: true },
  },

  data() {
    return { active: false, anexos: [] }
  },

  methods: {
    open() {
      this.active = true
    },
    close() {
      this.active = false
      this.anexos = []
    },

    onSelect(anexos) {
      this.$emit(
        "selected",
        anexos.map(({ descricao, file_info }) => ({
          tipo: descricao,
          ...file_info,
        })),
      )
      this.close()
    },
  },
}
</script>
